import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import { AppointmentType } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/appointment_type.pb';
import { CalendarEvent } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';

export type ExtendedAppointment = Appointment &
  // used for v3 only
  Pick<CalendarEvent, 'referenceId' | 'displayOptions'> & {
    appointmentTypeId?: string;
    isOverlapping?: boolean;
  };

export type RequestedOpeningInfo = {
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
};

export type ScheduleRequestEventData = Omit<ScheduleRequest, 'id'> & {
  appointmentTypeDetails: AppointmentType | undefined;
} & {
  allRequestedOpenings: RequestedOpeningInfo[] | undefined;
  otherRequestedOpenings: RequestedOpeningInfo[] | undefined;
  id: string | undefined; // `${ScheduleRequestId}-${index}` of the opening in the request's requestedOpenings array
  requestId: string | undefined; // original ScheduleRequest id
};

export const isScheduleRequestEventData = (
  request: ScheduleRequest | ScheduleRequestEventData | undefined
): request is ScheduleRequestEventData => (request as ScheduleRequestEventData)?.requestId !== undefined;

export type OverlappingCalendarEvent = ExtendedAppointment | ScheduleRequestEvent;

export type AiRequestDetails = {
  sourceDetails?: {
    source?: 'VOICE_AI' | 'SMS_AI' | string;
    threadId?: string;
    channelId?: string;
    messageId?: string;
  };
  schedulingPreferences?: {
    requestedSlots?: {
      rawText?: string;
    }[];
  };
  visitDetails?: {
    priority?: 'normal' | 'urgent';
    reasonForVisit?: string;
  };
  [key: string]: unknown;
};

export type ScheduleRequestListItem = ScheduleRequest & {
  aiRequestDetails?: AiRequestDetails; // AI Preference based request details
  bookableAppointmentTypeId?: string; // V3 request when schedule definition is enabled
};

export type ScheduleRequestEvent = Omit<ScheduleRequestListItem, 'requestedOpenings' | 'practitionerId'> & {
  requestId: string | undefined;
  operatoryId: string | undefined;
  organizerId: string | undefined;
  providerName: string | undefined;
  referenceTypeId: string | undefined;
  appointmentTypeName: string | undefined;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  displayOptions: {
    primaryColor: string;
    backgroundColor: string;
  };
  request: ScheduleRequestEventData;
  type: 'request';
};
